/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completePlasmaFlow} from '../api'

export const useMutationCompletePlasmaFlow = createReactQueryMutationHook('completePlasmaFlow', completePlasmaFlow)
